// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"769f6cf4","239":"cbe70960","732":"a14266c4"}[chunkId] + ".chunk.js";
};